export const contactData = {
  mainInfo: {
    phone: "+1 (555) 123-4567",
    email: "info@dhyota.com",
    address: "123 Health Street, Medical District, City, State 12345",
    hours: {
      weekdays: "Monday - Friday: 9:00 AM - 6:00 PM",
      weekends: "Saturday: 10:00 AM - 4:00 PM",
      sunday: "Sunday: Closed"
    }
  },
  
  departments: [
    {
      id: 1,
      name: "General Inquiries",
      email: "info@dhyota.com",
      phone: "+1 (555) 123-4567",
      description: "For general questions about our services and company information."
    },
    {
      id: 2,
      name: "Patient Support",
      email: "support@dhyota.com",
      phone: "+1 (555) 123-4570",
      description: "Technical support and assistance with our health platform."
    },
    {
      id: 3,
      name: "Media & Press",
      email: "media@dhyota.com",
      phone: "+1 (555) 123-4571",
      description: "Press inquiries, media partnerships, and public relations."
    },
    {
      id: 4,
      name: "Partnerships",
      email: "partnerships@dhyota.com",
      phone: "+1 (555) 123-4572",
      description: "Business partnerships, collaborations, and strategic alliances."
    }
  ],
  
  socialMedia: [
    {
      name: "Facebook",
      url: "https://facebook.com/dhyota",
      icon: "fab fa-facebook-f"
    },
    {
      name: "Twitter",
      url: "https://twitter.com/dhyota",
      icon: "fab fa-twitter"
    },
    {
      name: "LinkedIn",
      url: "https://linkedin.com/company/dhyota",
      icon: "fab fa-linkedin-in"
    },
    {
      name: "Instagram",
      url: "https://instagram.com/dhyota",
      icon: "fab fa-instagram"
    }
  ],
  
  faqs: [
    {
      id: 1,
      question: "What makes Dhyota different from other healthcare providers?",
      answer: "Dhyota focuses exclusively on men’s health, offering a holistic ecosystem that spans pharmaceuticals, medical devices, disposables, and medical coding. We combine innovation, research, and compassionate care to address every dimension of well-being—physical, emotional, mental, and social."
    },
    {
      id: 2,
      question: "How do I get started with Dhyota?",
      answer: "Getting started is simple! You can contact us through our website and linkedin page. We’ll guide you step by step to access the right services for your needs."
    },
    {
      id: 3,
      question: "Is my health information secure?",
      answer: "Absolutely. We use industry-standard encryption and security protocols to protect all personal health information. Data is stored securely, and we comply with global privacy regulations to ensure your confidentiality and peace of mind."
    },
    {
      id: 4,
      question: "What product categories do we offer??",
      answer: "We offer products across urological care, sexual health, personal hygiene, general wellness, grooming, and continence care."
    },
    {
      id: 5,
      question: "How can I partner with Dhyota?",
      answer: "We collaborate with pharmaceutical companies, medical device innovators, hospitals, specialty clinics, and research institutions. Partners benefit from our integrated men’s health ecosystem, innovation, and shared commitment to improving patient outcomes. Contact us via the Partner With Us page."
    }
  ]  
};
